module.exports = __webpack_public_path__ + "static/media/fansfirst-logo-mobile.1c2078ba.svg";